import Marquee from "react-fast-marquee";
import { SUCCESSES } from "@/data";
import { Star } from "lucide-react";

export default function SuccessMarquee() {
  return (
    <section data-testid="success-marquee" className="bg-foreground text-white py-4 border-y border-white/10 overflow-hidden max-w-[100vw]">
      <Marquee gradient={false} speed={45} pauseOnHover>
        {SUCCESSES.map((s, i) => (
          <div key={i} className="flex items-center gap-4 mx-12">
            <Star className="h-3.5 w-3.5 text-accent fill-accent" />
            <span className="font-mono-accent text-sm tracking-wider uppercase whitespace-nowrap">{s}</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
}
